import * as Yup from "yup";

// form field names
export type TFormFieldNames =
  | "geozonecategoryid"
  | "displayname"
  | "description"
  | "notes";

// initial values for the form
export const formInitialValues = {
  geozonecategoryid: "",
  displayname: "",
  description: "",
  notes: "",
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  geozonecategoryid: Yup.string()
    .required("Please enter the username of the user")
    .matches(
      /^[a-z0-9\-_]+$/,
      "Only lowercase characters, numbers, hyphens, and underscores are allowed"
    ),

  displayname: Yup.string().required("DIsplay name  is required"),

  description: Yup.string().required("Description is required"),
});
